import logo from "./logo.svg";
import { useState,useEffect } from "react";
import "./App.css";
import { Form } from "./modules/customer";
import { layout } from "@chakra-ui/react";
import Navbar from "./components/Navbar/Navbar";
//import Sidebar from "./components/Sidebar";
import Layout from "./layout/index";
import { Route,Routes } from "react-router-dom";
import Login from "./modules/auth/Login/Login";
import Signup from "./modules/auth/Signup/Signup";
import  Notes  from "./modules/billing/Note";
import ShowTodo from "./modules/billing/AddFood";
import  TextField  from "./modules/billing/TextField";
import Cookie from 'js-cookie'
import io from 'socket.io-client';
import toast from "react-hot-toast";



import { Toaster } from "react-hot-toast";

// const socket = io('https://api.hotel.tdrsoftware.in', {
//   transports: ['websocket'],
//   reconnection: true
// });

// socket.on('connect', () => console.log('Connected to Socket.IO'));
// socket.on('connect_error', (error) => console.error('Socket connection error:', error));
// const socket = io("https://api.hotel.tdrsoftware.in", {
//   transports: ["websocket", "polling"], // Ensure both WebSocket and polling are used
//   reconnection: true, // Enable automatic reconnection
//   reconnectionAttempts: 5, // Retry up to 5 times
//   reconnectionDelay: 2000, // Wait 2 seconds before retrying
// });

// socket.on("connect", () => {
//   console.log("Connected to Socket.IO:", socket.id);
// });

// socket.on("connect_error", (err) => {
//   console.error("Socket connection error:", err);
// });
const socket = io("https://api.hotel.tdrsoftware.in"
 );
//  socket.on("connect", () => {
//     console.log("Connected to Socket.IO:", socket.id);
//   });
  
//   socket.on("connect_error", (err) => {
//     console.error("Socket connection error:", err);
//   });



function App() {
  useEffect(() => {
    const customerId = localStorage.getItem('customerId'); // Assuming you store customerId in cookies
  
    // Join a room for this customerId
    socket.emit('joinRoom', customerId);
    
  
    // Listen for KOT generation events only for this room
    socket.on('roomBooked', (data) => {
      
      toast.custom((t) => (
        <div style={{
          position: 'relative',
          padding: '16px',
          backgroundColor: '#4CAF50',
          color: '#fff',
          borderRadius: '4px',      
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px',
        }}>
          <span>{data.message}</span>
          {/* <span>{data.serverName}</span> */}
          <button
            onClick={() => toast.dismiss(t.id)}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            &#10005; {/* Close icon */}
          </button>
        </div>
      ), {
        icon: '📢',
        duration: Infinity, // Keep the toast on screen until manually dismissed
      });
     // console.log(Received KOT event: ${data.message}, 'msg');
    });
    
  
    return () => {
      socket.off('roomBooked'); // Clean up the listener on component unmount
    };
  }, []);
 // const [showInput, setShowInput] = useState(false);
 const token=Cookie.get('token')
  return (<>{token ?  <div className="App" >
    <Toaster  toastOptions={{
  className: '',
  style: {
    
    padding: '10px',
    color: '#713200',
    width:"300px"
  },
}}   />
    <Layout/>
   
    
   
  </div> :  <div className="App" >
      <Toaster  toastOptions={{
    className: '',
    style: {
      
      padding: '10px',
      color: '#713200',
      width:"300px"
    },
  }}   />
      <Login/>
     
      
     
    </div> }</>
   
  );
}

export default App;
